import {defineStore} from 'pinia';
import {BaseStore} from '@/stores/baseStore';
import {ModuleDataManagement} from '../moduleConst';
import databaseAPI from '@/apis/system/databaseAPI';

/**
 * Store sao lưu dữ liệu
 * ndhieu3 25.04.2023
 */
const databaseStore = new BaseStore(databaseAPI);
export const useDatabaseStore = defineStore(ModuleDataManagement, {
  state: () => ({
    ...databaseStore.state,
    _config: {key: 'database_id', name: 'database_name', table: 'database', moduleName: 'Dữ liệu'},
    moduleName: 'dataManagement',
  }),
  actions: {
    ...databaseStore.action,
    /**
     * Lấy dữ liệu theo id
     * ndhieu3 24.05.2023
     * @param {*} id
     * @returns
     */
    async getById(id) {
      let res = null;
      try {
        res = await databaseAPI.getById(id);
      } catch (error) {
        console.log(error);
      }
      return res;
    },
    /**
     * Đổi database để thao tác
     * ndhieu3 19.06.2023
     * @param {*} payload
     * @returns
     */
    async updateActiveInfo(payload) {
      let res = null;
      try {
        res = await databaseAPI.updateActiveInfo(payload);
      } catch (error) {
        console.log(error);
      }
      return res;
    },
    /**
     * Validate trùng tên
     * @param {*} databaseName
     * @returns
     */
    async checkExistDatabaseName(databaseName) {
      let res = null;
      try {
        res = await databaseAPI.checkExistDatabaseName(databaseName);
      } catch (error) {
        console.log(error);
      }
      return res;
    },
    /**
     * Lấy dữ liệu database theo tenantId và userId
     * ndhieu3 24.05.2023
     * @param {*} tenantId
     * @param {*} userId
     * @param {*} isActive
     * @returns
     */
    async getByTenantAndUserId(tenantId, userId) {
      let res = null;
      try {
        res = await databaseAPI.getByTenantAndUserId(tenantId, userId);
      } catch (error) {
        console.log(error);
      }
      return res;
    },

    /**
     * Lấy dữ liệu dboption của db
     * ndhieu3 26.09.2023
     * @param {*} databaseId
     * @returns
     */
    async getInfoDb(databaseId) {
      let res = null;
      try {
        res = await databaseAPI.getInfoDb(databaseId);
      } catch (error) {
        console.log(error);
      }
      return res;
    },

    /**
     * Lấy dữ liệu database theo userId
     * pvdat1 19.09.2023
     * @param {*} userId
     * @param {*} isActive
     * @returns
     */
    async getByUserId(userId) {
      let res = null;
      try {
        res = await databaseAPI.getByUserId(userId);
      } catch (error) {
        console.log(error);
      }
      return res;
    },

    deleteItems(playload, res) {},

    /**
     * Thêm mới database_user
     * @param {*} payload
     * pdtai 25.05.2023
     */
    async insertDatabaseUser(payload) {
      const me = this;
      const res = await databaseAPI.insertDatabaseUser(payload);
      if (res) {
        me.items = [res, ...me.items];
      }
      return res;
    },

    /**
     * Tạo dữ liệu lần đầu đăng nhập
     * @param {*} payload
     * nvxuan 14.09.2023
     */
    async createNewDatabaseFirstLogin(payload) {
      return await databaseAPI.createNewDatabaseFirstLogin(payload);
    },

    /**
     * Tạo dữ liệu mới
     * @param {*} payload
     * @return
     * nvxuan 21.09.2023
     */
    async createNewDatabase(payload) {
      return await databaseAPI.createNewDatabase(payload);
    },

    /**
     * Lấy danh sách các bản ghi backup theo dbid
     * @param {*} payload
     * @return
     * nvxuan 20.11.2023
     */
    async getBackupByDbId() {
      return await databaseAPI.getBackupByDbId();
    },

    /**
     * Kiểm tra dữ liệu trước khi backup
     * @param {*} payload
     * @return
     * nvxuan 24.11.2023
     */
    async checkBeforeBackup(payload) {
      return await databaseAPI.checkBeforeBackup(payload);
    },

    /**
     * Thực hiện backup dữ liệu
     * nvxuan 20.11.2023
     */
    async executeBackupData(payload) {
      return await databaseAPI.executeBackupData(payload);
    },

    /**
     * Thực hiện tạo dữ liệu mới từ dữ liệu cũ
     * tvtoan 10.01.2024
     */
    async executeCreateDataFromOldData(payload) {
      return await databaseAPI.executeCreateDataFromOldData(payload);
    },

    /**
     * Tách dữ liệu theo Thông tư 107/2026/TT-BTC
     * @param {*} payload
     */
    async createDatabaseByCircular(payload) {
      return await databaseAPI.createDatabaseByCircular(payload);
    },

    /**
     * Lấy danh sách task tách dữ liệu TT107 đang xử lý của tenant hiện tại
     */
    async getCircularInProgress() {
      return await databaseAPI.getCircularInProgress();
    },

    /**
     * Validate db nguồn (TT78) trước khi tách dữ liệu: trả về list tài khoản có số dư
     * nhưng chưa ánh xạ sang Thông tư 107/2026/TT-BTC.
     * @param {*} payload — { source_database_id, from_date }
     */
    async getAccountNoMappingTT107(payload) {
      return await databaseAPI.getAccountNoMappingTT107(payload);
    },

    /**
     * Hủy sao lưu dữ liệu
     * nvxuan 20.11.2023
     */
    async cancelBackupData(id) {
      return await databaseAPI.cancelBackupData(id);
    },

    /**
     * Hủy khôi phục dữ liệu
     * nvxuan 20.11.2023
     */
    async cancelRestoreData(id) {
      return await databaseAPI.cancelRestoreData(id);
    },

    /**
     * Hủy task tách dữ liệu theo Thông tư 107/2026/TT-BTC đang chạy (theo circular_id)
     */
    async cancelCircular(id) {
      return await databaseAPI.cancelCircular(id);
    },

    /**
     * Lấy bản ghi backup theo id
     * nvxuan 20.11.2023
     */
    async getBackupById(id) {
      return await databaseAPI.getBackupById(id);
    },

    /**
     * lấy thông tin tiến trình tạo database từ batabase cũ
     * tvtoan 23.01.2024
     */
    async getInfoProcessCreateData(id) {
      return await databaseAPI.getInfoProcessCreateData(id);
    },

    /**
     * lấy thông tin tiến trình tạo database từ batabase cũ (lấy tất cả)
     * tvtoan 23.01.2024
     */
    async getAllProcessCreateData(id) {
      return await databaseAPI.getAllProcessCreateData(id);
    },

    /**
     * Lấy bản ghi restore theo id
     * nvxuan 22.11.2023
     */
    async getRestoreById(id) {
      return await databaseAPI.getRestoreById(id);
    },

    /**
     * Lấy dữ liệu danh sách các bản sao lưu theo tenant
     * nvxuan 22.11.2023
     */
    async getBackupByTenant(tenantId) {
      return await databaseAPI.getBackupByTenant(tenantId);
    },

    /**
     * Xóa bản sao lưu dữ liệu
     * NVXUAN 22.11.2023
     */
    async removeBackupRecord(payload) {
      return await databaseAPI.removeBackupRecord(payload);
    },

    /**
     * Thực hiện khôi phục dữ liệu
     * nvxuan 20.11.2023
     */
    async executeRestoreData(payload) {
      return await databaseAPI.executeRestoreData(payload);
    },

    /**
     * Lấy bản ghi đang khôi phục theo người dùng và ID bản sao lưu
     * nvxuan 23.11.2023
     */
    async getRestoringByUserIdBackupId(payload) {
      return await databaseAPI.getRestoringByUserIdBackupId(payload);
    },

    /**
     * Kiểm tra xem người dùng userId có quyền admin tại database dbId hay không
     * @param {*} userId
     * @param {*} dbId
     * nvxuan 11.12.2023
     */
    async checkIsAdminByDatabaseId(userId, dbId) {
      return await databaseAPI.checkIsAdminByDatabaseId(userId, dbId);
    },
  },
  getters: {
    ...databaseStore.getters,
  },
});
